/**
 * created by lei lei
 * 横向管控统计分析
 *
 */
import React from 'react';
import Title from "../../../components/title/Title";
import {Tooltip, Tabs, Divider, Pagination} from "antd";
import weChat from './img/wechat.png'
import microBlog from './img/microBlog.png'
import tiktok from './img/tiktok.png'
import {Scrollbars} from "react-custom-scrollbars";
import CustomTable from "../../../components/customTable/CustomTable";
import IconStatistic from "../../../components/iconStatistic/IconStatistic";
import NumberArticles from "../../../components/numberArticles/NumberArticles";
import TrendAnalysis from "../../../components/trendAnalysis/TrendAnalysis";
import SpacerBlock from "../../../components/spacerBlock/SpacerBlock";
import * as Action from '../../actions/horizontalManagement'
import moment from 'moment';
import * as utils from "../../../../utils";
import WeChatReview from "../../../components/weChatReview/WeChatReview";
import MicroBlogReview from "../../../components/microBlogReview/MicroBlogReview";
import TiktokReview from "../../../components/tiktokReview/TiktokReview";
import {connect} from "react-redux";
import {
    NAVIGATE_CLOSE,
    NAVIGATE_OPEN,
    NAVIGATE_LEVEN2_WIDTH,
    NAVIGATE_LEVEN2_MARGIN,
    HEADER_HEIGHT
} from "../../../../constants";
import * as myMediaActions from "../../actions/myMedia";
import {getAllNewMediaList} from "../../actions/newMediaManage";
import BaseComponent from "../../../../base/BaseComponent";

const {TabPane} = Tabs;

let wcSummary = [
    {
        title: '今日群发数',
        num: 0
    },
    {
        title: '今日图文数',
        num: 0
    },
    {
        title: '昨日阅读',
        num: 0
    },
    {
        title: '昨日点赞',
        num: 0
    },
    {
        title: '昨日在看',
        num: 0
    }];
let wbSummary = [
    {
        title: '今日净增粉丝数',
        num: 0
    },
    {
        title: '累积粉丝',
        num: 0
    },
    {
        title: '今日发布',
        num: 0
    },
    {
        title: '今日转发',
        num: 0
    },
    {
        title: '今日评论',
        num: 0
    },
    {
        title: '今日点赞',
        num: 0
    }];
let dySummary = [
    {
        title: '今日净增粉丝数',
        num: 0
    },
    {
        title: '累积粉丝',
        num: 0
    },
    {
        title: '今日发布',
        num: 0
    },
    {
        title: '今日转发',
        num: 0
    },
    {
        title: '今日评论',
        num: 0
    },
    {
        title: '今日点赞',
        num: 0
    }];

class ManageControlStatistics extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Actions = Action;
        this.state = {
            mediaType: '2',//3个导航tab类型；
            //媒体类型具体的个数最上面切换。
            weiChatCount: 0,//微信
            weiBoCount: 0,//微博个数
            douYinCount: 0,//抖音个数
            //总览数据源
            summary: [],
            //账号明细
            page: 1,//总览页数
            size: 10,//每页数据数
            accountList: [],//账号明细数据源
            numberOfElements: 0,//账号明细条数
            //趋势分析
            statisticsTypeKey: null,//时间前面的统计类型
            startDate: moment().add(-6, 'days'),//开始时间
            endDate: moment(),//结束时间
            modalList: [],//统计的媒体列表数据
            strMediaIds: [],//查询的媒体id集合
            option: { //当前展示的数据源
                xData: [],
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],
                yData: [/*{
                    name: '拨打订阅号',
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,]
                }*/]

            },
            optionDataSource: [],//请求到数据组合的数据源
            dataSource: [],//单位数据源
            deptId: null,

            isUpdate: false,
            //热门文章
            timeType: 30,
            //粉丝数据源
            hotList: [],
            fanSList: [],
            isSecondary: false,
            mediaAllIds: '',
            weChatMediaIds: '',
            weiBoMediaIds: '',
            tiktokMediaIds: '',
            mediaCodes: [],
            hideOnSinglePage: true,
            isFirst: true
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let params = {
            pageNum: 1,
            pageSize: 10,
            statusType: 0
        }
        if (this.permissionCheck("pms:accountManage:all")) {

        } else if (this.permissionCheck("pms:accountManage:dept")) {
            params.createUserDeptIds = [window.top.currentUser.defaultInfo.dept.id];  //部门权限
        } else {
            params.createBy = window.top.currentUser.id;  //个人权限
        }
        getAllNewMediaList(params, (data) => {
            let mediaCodes = ["default"];
            data && data.length > 0 && data.forEach(item => {
                mediaCodes.push(item.code);
            })
            this.state.mediaCodes = mediaCodes;
            this.getMediaCount(mediaCodes);//初始化媒体数
            if (this.props.match.params.isSecondary) {
                this.state.isSecondary = true;
                this.getMediaList(mediaCodes);
            } else {
                this.state.option.xData = [];
                let dateArry = utils.formatEveryDay(this.state.startDate.format('YYYY/MM/DD '), this.state.endDate.format('YYYY/MM/DD '));//取出时间每一天，放到统计图x轴

                this.state.option.xData = dateArry;
                // this.getMediaCount();//初始化媒体数
                this.getDeptAll();//获取所有部门
                //根据不同的类型，获取不同的数据
                this.accordingToGetData(mediaCodes, true);
                this.TrendAnalysis.init('2');//初始化统计
            }
        })
    }

    //获取媒体列表
    getMediaList(mediaCodes) {
        let deptIds = this.props.currentUser.deptIds.toString();
        //获取媒体列表；
        let mediaWechatIds = [];
        let mediaWeiboIds = [];
        let mediaTiktokIds = [];
        let mediaAllIds = [];
        myMediaActions.getMediaList(deptIds, (data) => {
            let _data = data && data.data;
            if (_data && _data.length > 0) {
                _data.forEach((item, i) => {
                    mediaAllIds.push(item.code);
                    if (item.type === 2) {
                        mediaWechatIds.push(item.code)
                    } else if (item.type === 3) {
                        mediaWeiboIds.push(item.code)
                    } else if (item.type === 5) {
                        mediaTiktokIds.push(item.code)
                    }
                });
                this.state.mediaAllIds = mediaAllIds.toString();
                this.state.weChatMediaIds = mediaWechatIds.toString();
                this.state.weiBoMediaIds = mediaWeiboIds.toString();
                this.state.tiktokMediaIds = mediaTiktokIds.toString();
            }
            this.state.option.xData = [];
            let dateArry = utils.formatEveryDay(this.state.startDate.format('YYYY/MM/DD '), this.state.endDate.format('YYYY/MM/DD '));//取出时间每一天，放到统计图x轴

            this.state.option.xData = dateArry;
            this.getMediaCount(mediaCodes);//初始化媒体数
            this.getDeptAll();//获取所有部门
            //根据不同的类型，获取不同的数据
            this.accordingToGetData(mediaCodes, true);
            this.TrendAnalysis.init();//初始化统计

        });
    }

    getDeptAll() {
        if (this.permissionCheck("pms:accountManage:all")) {
            this.Actions.getDeptAll((data) => {
                if (data && data.length > 0) {
                    this.setState({
                        dataSource: data
                    })
                }
            })
        } else {
            this.Actions.getCurrentDeptByIds(window.top.currentUser.deptIds, (data) => {
                if (data && data.length > 0) {
                    this.setState({
                        dataSource: data
                    })
                }
            })
        }
    }

    //根据类型获取不同数据
    accordingToGetData(mediaCodes, isFirst) {
        this.getCollectData(mediaCodes); //汇总数据
        this.accountChangeType(mediaCodes);//账号明细
        this.getAllMedia(isFirst);//趋势分析
        this.dataTimeChange(mediaCodes);//热门文章
    }

    getCollectData(mediaCodes) {
        if (this.state.mediaType === '2') {
            this.getWechatStatisticsQuery(mediaCodes);//微信汇总数据
            this.getWeChatFansTop10(mediaCodes);//获取微信粉丝数
        } else if (this.state.mediaType === '3') {
            this.getWeiboStatisticsQuery(mediaCodes);//微博汇总数据
            this.getWeiBoFansTop10(mediaCodes);//获取微博粉丝数

        } else if (this.state.mediaType === '5') {
            this.getDouyinStatisticsQuery(mediaCodes);
            this.getDouYinFansTop10(mediaCodes);//获取抖音粉丝数
        }
    }

    tabOnchange(key) {
        this.state.summary = [];
        this.state.mediaType = key;
        this.state.page = 1;
        this.state.size = 10;
        this.state.statisticsTypeKey = null;
        this.setState({mediaType: key});
        let that = this;
        setTimeout(function () {
            that.accordingToGetData(that.state.mediaCodes, true);
        }, 500);//延时是为了解决卡顿的问题
        // this.accordingToGetData();
        this.TrendAnalysis.init(key);
    }


    render() {
        let margin = 15;
        let height = window.innerHeight - HEADER_HEIGHT - margin - 15;
        return (
            <div className={'PageScrollBars'} style={{margin, position: 'relative', height: height}}>
                <Scrollbars
                    autoHide={true}
                    style={{borderRadius: "5px"}}
                >
                    <div className={'ManageControlStatistics'}>
                        {/*<Title title={'统计分析'}/>*/}

                        <div style={{background: 'white', paddingLeft: "15px", borderRadius: "5px"}}>
                            <Tabs defaultActiveKey={this.state.mediaType} activeKey={this.state.mediaType}
                                  onChange={(key) => {
                                      this.tabOnchange(key);
                                  }} tabBarGutter={0}>
                                <TabPane tab={<span><img style={{width: 15, objectFit: 'cover'}} src={weChat}
                                                         alt=""/> 公众号（{this.state.weiChatCount}）</span>} key={'2'}>
                                </TabPane>
                                <TabPane tab={<span><img style={{width: 15, objectFit: 'cover'}} src={microBlog}
                                                         alt=""/> 微博（{this.state.weiBoCount}）</span>}
                                         key={'3'}>
                                </TabPane>
                                <TabPane tab={<span><img style={{width: 15, objectFit: 'cover'}} src={tiktok}
                                                         alt=""/> 抖音（{this.state.douYinCount}）</span>} key={'5'}>
                                </TabPane>
                            </Tabs>
                        </div>
                        <div>
                            <div style={{height: 20}}></div>
                            {this.renderAllData()}
                        </div>
                        {/*<SpacerBlock/>*/}
                        <div style={{height: 20}}></div>
                        <div>
                            <Title title={'账号明细'}/>
                            {this.state.mediaType === '2' ? this.renderWeChatAccount() : null}
                            {this.state.mediaType !== '2' ? this.renderWeiBoOrDouYinAccount() : null}
                        </div>
                        <div style={{height: 20}}></div>
                        <div>
                            <Title title={'趋势分析'}/>
                            {this.renderTrendAnalysis()}
                        </div>
                        <div style={{height: 20}}></div>
                        <div>
                            {this.renderArticlesAndFans()}
                        </div>
                        {/*// 微信预览*/}
                        <WeChatReview ref={(WeChatReview) => {
                            this.WeChatReview = WeChatReview
                        }}/>
                        {/*微博预览*/}
                        <MicroBlogReview ref={(MicroBlogReview) => {
                            this.MicroBlogReview = MicroBlogReview
                        }}/>
                        {/*抖音预览*/}
                        <TiktokReview ref={(TiktokReview) => {
                            this.TiktokReview = TiktokReview
                        }}/>
                    </div>
                </Scrollbars>
            </div>
        )
    }

    //渲染汇总数据
    renderAllData() {
        //根据顶部的tab 切换，更换第一列的图标
        let iconType = 'weChat';
        let num = 0;
        let color = 'black';
        if (this.state.mediaType === '2') {
            iconType = 'weChat';
            color = '#62c277';
            num = this.state.weiChatCount;
        } else if (this.state.mediaType === '3') {
            iconType = 'microBlog';
            color = '#de6261';
            num = this.state.weiBoCount;
        } else if (this.state.mediaType === '5') {
            iconType = 'tiktok';
            color = '#c45a8e';
            num = this.state.douYinCount;
        }
        let menuWidth = parseInt(NAVIGATE_OPEN);
        if (!this.props.navigateStatus) {
            menuWidth = parseInt(NAVIGATE_CLOSE);
        }

        let dialogWidth = parseInt(window.$(window).width());
        let menu2 = parseInt(NAVIGATE_LEVEN2_WIDTH);
        let menu2Space = parseInt(NAVIGATE_LEVEN2_MARGIN);
        let iconWidth = 210;
        let contentWidth = dialogWidth - menuWidth - 40 - menu2 - menu2Space - iconWidth;
        if (this.state.isSecondary) {
            contentWidth = contentWidth + menu2 + menu2Space
        }
        if (this.state.mediaType === "3" || this.state.mediaType === "5") {
            contentWidth = contentWidth - 234
        }
        return (
            <div>
                <div style={{display: 'flex', justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{width: iconWidth}}>
                        <IconStatistic
                            iconType={iconType}
                            title={'总计'}
                            numAll={num}
                            mark={''}
                            background={color}
                            color={'white'}
                            onClickFunction={() => {
                                console.log('点击了某一项')
                            }}
                        /></div>
                    {this.state.summary.map((item, i) => {
                        return (
                            <NumberArticles
                                key={i}
                                title={item.title}
                                num={item.num}
                                color={color}
                            />

                        )
                    })}
                </div>
            </div>
        )
    }

    //渲染微信账号明细
    renderWeChatAccount() {
        let titleKeyList = [
            {
                key: 'mediaName', titleName: '账号名称', ellipsis: true, width: 200,
                render: (text, record) => {
                    let mediaName = record.mediaName;
                    let showText;
                    if (record && mediaName && mediaName.indexOf("[") > -1 && mediaName.indexOf("]") > -1) {
                        let status = mediaName.substring(record.mediaName.indexOf("[") + 1, mediaName.indexOf("]"));
                        let index = mediaName.lastIndexOf("[");
                        let content = mediaName.slice(0, index);
                        showText = (<span>{content}[<span style={{color: "red"}}>{status}</span>]</span>)
                    } else {
                        showText = mediaName;
                    }
                    return (<div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>{showText}</div>)
                }
            },
            {key: 'massNumber', titleName: '今日群发数', ellipsis: true},
            {key: 'articleCount', titleName: '今日图文数', ellipsis: true},
            {key: 'readNum', titleName: '昨日阅读', ellipsis: true},
            {key: 'likeNum', titleName: '昨日点赞', ellipsis: true},
            {key: 'inSight', titleName: '昨日在看'}];
        return (
            <div id={"wechat"} style={{backgroundColor: "#fff", borderRadius:"0 0 5px 5px"}}>
                <Scrollbars autoHide autoHeight autoHeightMax={400} style={{right: 10}}>
                    <CustomTable
                        defineStyle={{background: 'white', padding: 20, borderRadius:"0 0 5px 5px", marginLeft: 10}}
                        dataSource={this.state.accountList}
                        titleKeyList={titleKeyList}
                        //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                        pagination={false}
                    />
                </Scrollbars>
                <div>
                    <Divider style={{display: this.state.accountList.length>0 ? "block" : "none"}}/>
                    <div style={{
                        padding: "8px 10px",
                        display: "flex",
                        justifyContent: "flex-end",
                        backgroundColor: "#ffffff",
                        borderRadius: "0 0 5px 5px"
                    }}>
                        <Pagination
                            onChange={(page, pageSize) => {
                                this.accountPaginationChange(page, pageSize)
                            }}//页码改变回调
                            onShowSizeChange={(page, pageSize) => {
                                this.state.hideOnSinglePage = false;
                                this.accountPaginationChange(page, pageSize)
                            }}//每页条数改变回调
                            defaultCurrent={1}
                            defaultPageSize={10}
                            total={this.state.numberOfElements}
                            showTotal={total => `共${total}条`}
                            current={this.state.page}
                            pageSize={this.state.size}
                            showSizeChanger
                            showQuickJumper
                            hideOnSinglePage={this.state.hideOnSinglePage}
                        />
                    </div>
                </div>
                <style>{`#wechat .ant-divider-horizontal{margin: 0px;height: 0.5px;}`}</style>
            </div>
        )
    }

    //渲染微博抖音账号明细
    renderWeiBoOrDouYinAccount() {
        let titleKeyList =
            [{
                key: 'mediaName',
                titleName: '账号名称',
                ellipsis: true,
                width: 200,
                render: (text, record) => {
                    let mediaName = record.mediaName;
                    let showText;
                    if (record && mediaName && mediaName.indexOf("[") > -1 && mediaName.indexOf("]") > -1) {
                        let status = mediaName.substring(record.mediaName.indexOf("[") + 1, mediaName.indexOf("]"));
                        let index = mediaName.lastIndexOf("[");
                        let content = mediaName.slice(0, index);
                        showText = (<span>{content}[<span style={{color: "red"}}>{status}</span>]</span>)
                    } else {
                        showText = mediaName;
                    }
                    return (<div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>{showText}</div>)
                }
            }, {
                key: 'incrFansCount',
                titleName: '今日净增粉丝数',
                ellipsis: true,
            },
                {
                    key: 'totalFansCount',
                    titleName: '累积粉丝',
                },
                {
                    key: 'totalPublishCount',
                    titleName: '今日发布',
                },
                {
                    key: 'forwardCount',
                    titleName: '今日转发',
                },
                {
                    key: 'commentCount',
                    titleName: '今日评论',
                }, {
                key: 'likeCount',
                titleName: '今日点赞',
            }];
        return (
            <div id={"weiboOrDouyin"} style={{backgroundColor: "#fff", borderRadius:"0 0 5px 5px"}}>
                <Scrollbars autoHide autoHeight autoHeightMax={400} style={{right: 10}}>
                    <CustomTable
                        dataSource={this.state.accountList}
                        defineStyle={{background: 'white', padding: 20, borderRadius:"0 0 5px 5px", marginLeft: 10}}
                        titleKeyList={titleKeyList}
                        //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                        pagination={false}
                    />
                </Scrollbars>
                <div>
                    <Divider style={{display: this.state.accountList.length>1 ? "block" : "none"}}/>
                    <div style={{
                        padding: "8px 10px",
                        display: "flex",
                        justifyContent: "flex-end",
                        backgroundColor: "#ffffff",
                        borderRadius: "0 0 5px 5px"
                    }}>
                        <Pagination
                            onChange={(page, pageSize) => {
                                this.accountPaginationChange(page, pageSize)
                            }}//页码改变回调
                            onShowSizeChange={(page, pageSize) => {
                                this.state.hideOnSinglePage = false;
                                this.accountPaginationChange(page, pageSize)
                            }}//每页条数改变回调
                            defaultCurrent={1}
                            defaultPageSize={10}
                            total={this.state.numberOfElements}
                            showTotal={total => `共${total}条`}
                            current={this.state.page}
                            pageSize={this.state.size}
                            showSizeChanger
                            showQuickJumper
                            hideOnSinglePage={this.state.hideOnSinglePage}
                        />
                    </div>
                </div>
                <style>{`#weiboOrDouyin .ant-divider-horizontal{margin: 0px;height: 0.5px}`}</style>
            </div>
        )
    }

    //渲染趋势分析
    renderTrendAnalysis() {
        return (
            <div style={{background: 'white', borderRadius: "0px 0px 5px 5px"}}>
                <TrendAnalysis
                    mediaType={this.state.mediaType}
                    option={this.state.option}
                    topMarkNumBtnClick={(data) => {
                        this.state.statisticsTypeKey = data;
                        this.statisticsChange(this.state.isFirst);//微信微博抖音，粉丝类筛选条件改变时，调用
                    }}
                    topTimeBtnClick={(data) => {
                        //console.log('时间按钮', data); 、、时间是moment()格式
                        this.state.startDate = data.startDate;
                        this.state.endDate = data.endDate;
                        this.statisticsChange(this.state.isFirst);//调用接口获取统计*/
                    }}
                    dataSource={this.state.dataSource} // 单位数据源
                    modalList={this.state.modalList}
                    modalItemKey={'name'}
                    isUpdate={this.state.isUpdate}
                    companyCallback={(data) => {
                        this.state.deptId = data;
                        this.departChange(true);
                        // console.log('选择单位的数据', data)
                    }}
                    modalOkCallback={(data) => {
                        if (data && data.length > 0) {
                            this.state.strMediaIds = data;//赋值选中的媒体
                            this.statisticsChange(false);
                        } else {
                            this.state.deptId = null;
                            this.getAllMedia()
                        }
                    }}
                    ref={(TrendAnalysis) => this.TrendAnalysis = TrendAnalysis}
                    getAllMedia={() => {
                        this.getAllMedia()
                    }}
                />
            </div>
        )
    }

    //渲染文章和粉丝
    renderArticlesAndFans() {
        return (
            <div>
                <div style={{display: 'flex'}}>
                    <div style={{position: 'relative'}}><Title
                        title={'热门文章Top10'}
                    />
                        <div style={{background: 'white', borderRadius: "0px 0px 5px 5px"}}>
                            {this.renderArticles()}
                        </div>
                    </div>
                    <div style={{width: 20}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    <div><Title
                        title={this.state.mediaType === "2" ? '近期活跃Top10' : '粉丝量Top10'}
                    />
                        <div style={{background: 'white', borderRadius: "0px 0px 5px 5px"}}>
                            {this.renderFans()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    //渲染热门文章
    renderArticles() {
        let titleName;
        if (this.state.mediaType === '2') {
            titleName = '阅读量'
        } else if (this.state.mediaType === '3') {
            titleName = '转评赞'
        } else if (this.state.mediaType === '5') {
            titleName = '转评赞'
        }
        let titleKeyList =
            [{
                key: 'key',
                titleName: '序号',
                ellipsis: true,
                width: 70
            }, {
                key: 'title',
                titleName: '标题',
                ellipsis: true,
                render: (text, record, index) => {
                    return (<div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontWeight: 'bold',
                            cursor: 'pointer'
                        }}
                                 onClick={() => {
                                     this.hotItemClick(record)
                                 }}>
                            <Tooltip key={index} placement={"topLeft"}
                                     title={record.title}>{record.title ? record.title : '暂无标题'}</Tooltip>
                        </div>

                    )
                }
            },
                {
                    key: 'publishDate',
                    titleName: '发布时间',
                    ellipsis: true,
                    render: (text, record) => {
                        return <div>{utils.formatMediaDate(record.publishDate).replaceAll('/', '-')}</div>
                    }
                },
                {
                    key: 'mediaAccountName',
                    titleName: '账号名称',
                    ellipsis: true,
                },
                {
                    key: 'deptName',
                    titleName: '主责单位',
                    ellipsis: true,
                },
                {
                    key: 'zpzCount',
                    titleName: titleName,
                    width: 100,
                    render: (text,record) => {
                        return <span>{utils.formatCount(record.zpzCount)}</span>
                    }
                },];
        return (
            <div style={{borderRadius: "0px 0px 5px 5px", height: 623}} className={'articles'}>
                <CustomTable
                    dataSource={this.state.hotList}
                    titleKeyList={titleKeyList}
                    pagination={false}
                />
                <style>{`.articles .ant-empty-normal{margin-top:210px}`}</style>
            </div>

        )
    }

    //渲染粉丝数
    renderFans() {
        let titleKeyList = [
            {key: 'sort', titleName: '序号', ellipsis: true, width: 70},
            {key: 'mediaAccountName', titleName: '账号名称', ellipsis: true},
            {key: 'deptName', titleName: '主责单位', ellipsis: true},
            {key: 'fansCount', titleName: '粉丝数', width: 100}];
        if (this.state.mediaType === "2") {
            titleKeyList = [
                {key: 'sort', titleName: '序号', ellipsis: true, width: 70},
                {key: 'mediaAccountName', titleName: '账号名称', ellipsis: true},
                {key: 'account', titleName: '媒体账号', ellipsis: true},
                {key: 'deptName', titleName: '主责单位', ellipsis: true},
                {key: 'massNumber', titleName: '近七日群发', width: 150}];
        }
        return (
            <div style={{height: 623}}>
                <CustomTable className={'articles'}
                    dataSource={this.state.fanSList}
                    titleKeyList={titleKeyList}
                    pagination={false}
                />
            </div>
        )
    }

    //----------获取数据----------
    //获取媒体数
    getMediaCount(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getMediaCount(params, (data) => {
            if(data){
                this.setState({
                    weiChatCount: data[2] ? data[2] : 0,
                    weiBoCount: data[3] ? data[3] : 0,
                    douYinCount: data[5] ? data[5] : 0
                });
            }
        })
    }

    //-----------获取汇总数据--------

    //获取微信汇总数据
    getWechatStatisticsQuery(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getWechatStatisticsQuery(params, (data) => {
            let newData = data;
            if (newData) {
                wcSummary[0].num = newData.massNumber;
                wcSummary[1].num = newData.articleCount;
                wcSummary[2].num = newData.readNum;
                wcSummary[3].num = newData.likeNum;
                wcSummary[4].num = newData.inSight;
            }
            this.setState({
                summary: wcSummary
            });
        })
    }

    //获取微博汇总数据
    getWeiboStatisticsQuery(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getWeiboStatisticsQuery(params, (data) => {
            let newData = data;
            if (newData) {
                wbSummary[0].num = newData.incrFansCount;
                wbSummary[1].num = newData.totalFansCount;
                wbSummary[2].num = newData.totalPublishCount;
                wbSummary[3].num = newData.forwardCount;
                wbSummary[4].num = newData.commentCount;
                wbSummary[5].num = newData.likeCount;
            }
            this.setState({
                summary: wbSummary
            });
        })
    }

    //获取抖音汇总数据
    getDouyinStatisticsQuery(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getDouyinStatisticsQuery(params, (data) => {
            let newData = data;
            if (newData) {
                dySummary[0].num = newData.incrFansCount;
                dySummary[1].num = newData.totalFansCount;
                dySummary[2].num = newData.totalPublishCount;
                dySummary[3].num = newData.forwardCount;
                dySummary[4].num = newData.commentCount;
                dySummary[5].num = newData.likeCount;
            }
            this.setState({
                summary: dySummary
            });
        })
    }

    //-----------------获取账号明细-------------

    //账号明细改变时候这么做是为了局部刷新只刷新账号明细，主要是分页局部刷新
    accountChangeType(mediaCodes) {
        console.log(this.state.mediaType, 'mediaType')
        if (this.state.mediaType === '2') {
            this.getWechatAccountDetailQuery(mediaCodes);//获取微信账号明细
        } else if (this.state.mediaType === '3') {
            this.getWeiboAccountDetailQuery(mediaCodes);//获取微博账号明细
        } else if (this.state.mediaType === '5') {
            this.getDouyinAccountDetailQuery(mediaCodes);//抖音账号明细
        }
    }

    //获取微信账号明细
    getWechatAccountDetailQuery(mediaCodes) {
        let body = {
            page: this.state.page,
            size: this.state.size
        };
        if (mediaCodes.length) {
            body.mediaCodes = mediaCodes;
        }
        this.Actions.getWechatAccountDetailQuery(body, (data) => {
            let numberOfElements = 0;
            let hideOnSinglePage = true;
            let accountList = [];
            if (data && data.content && data.content.length) {
                numberOfElements = data.totalElements;
                hideOnSinglePage = false;
                accountList = data.content //账号明细数据源
            }
            this.setState({
                accountList,//账号明细数据源
                numberOfElements,//账号明细条数
                hideOnSinglePage
            })
        })
    }

    //获取微博账号明细
    getWeiboAccountDetailQuery(mediaCodes) {
        let body = {
            page: this.state.page,
            size: this.state.size
        };
        if (mediaCodes.length) {
            body.mediaCodes = mediaCodes;
        }
        this.Actions.getWeiboAccountDetailQuery(body, (data) => {
            let numberOfElements = 0;
            let hideOnSinglePage = true;
            let accountList = [];
            if (data && data.content && data.content.length) {
                numberOfElements = data.totalElements;
                hideOnSinglePage = false;
                accountList = data.content //账号明细数据源
            }
            this.setState({
                accountList,//账号明细数据源
                numberOfElements,//账号明细条数
                hideOnSinglePage
            })
        })
    }

    //获取抖音账号明细
    getDouyinAccountDetailQuery(mediaCodes) {
        let body = {
            page: this.state.page,
            size: this.state.size
        };
        if (mediaCodes.length) {
            body.mediaCodes = mediaCodes;
        }
        this.Actions.getDouyinAccountDetailQuery(body, (data) => {
            let numberOfElements = 0;
            let hideOnSinglePage = true;
            let accountList = [];
            if (data && data.content && data.content.length) {
                numberOfElements = data.totalElements;
                hideOnSinglePage = false;
                accountList = data.content //账号明细数据源
            }
            this.setState({
                accountList,//账号明细数据源
                numberOfElements,//账号明细条数
                hideOnSinglePage
            })
        })
    }

    //---------------------趋势分析-----------------------

    //根据类型获取媒体列表
    getAllMedia(isFirst) {
        let type = this.state.mediaType;
        this.state.option.yData = [];
        this.getMediaDataByType(type, null, isFirst);
    }

    getMediaDataByType(type, mediaCodeStrs, isFirst, isInitSelect) {
        let body = {};
        if (mediaCodeStrs) {
            body.mediaCodeStrs = mediaCodeStrs;
        }
        if (this.state.deptId) {
            body.deptIds = [this.state.deptId];
        }
        if (this.state.mediaCodes.length) {
            body.mediaCodes = this.state.mediaCodes;
        }
        if (type === '2') {
            this.Actions.getWeChatData(body, (data) => {
                this.getMediaData(data,isFirst,isInitSelect);
            })
        } else if (type === '3') {
            this.Actions.getWeiBoData(body, (data) => {
                this.getMediaData(data,isFirst,isInitSelect);
            })
        } else if (type === '5') {
            this.Actions.getDouYinData(body, (data) => {
                this.getMediaData(data,isFirst,isInitSelect);
            })
        }
    }

    getMediaData(data,isFirst,isInitSelect) {
        if (data && data.length > 0) {
            if(!isInitSelect){
                this.state.strMediaIds = [];
                data.forEach(item => {
                    this.state.strMediaIds.push(item.code);
                })
                this.statisticsChange(isFirst);
            }else{
                console.log(this.mediaCodes)
                //点击选择媒体时对比选中
                this.mediaCodes.length && this.mediaCodes.forEach(item => {
                    data.forEach(i => {
                        if (item === i.code) {
                            i.checked = true
                        }
                    })
                })
            }
            this.setState({
                modalList: data,
                isUpdate: true,
            });
        } else {
            this.setState({
                modalList: [],
                isUpdate: true,
            });
        }
    }

    departChange(isInitSelect) {
        let type = this.state.mediaType;
        let mediaCodeStrs;
        if (type === '2') {
            mediaCodeStrs = this.state.isSecondary ? (this.state.weChatMediaIds ? this.state.weChatMediaIds : '-1') : ''
        } else if (type === '3') {
            mediaCodeStrs = this.state.isSecondary ? (this.state.weiBoMediaIds ? this.state.weiBoMediaIds : '-1') : ''
        } else if (type === '5') {
            mediaCodeStrs = this.state.isSecondary ? (this.state.tiktokMediaIds ? this.state.tiktokMediaIds : '-1') : ''
        }
        this.getMediaDataByType(type, mediaCodeStrs, null, isInitSelect);
    }

    statisticsChange(isFirst) {
        this.state.isFirst = isFirst;
        if (this.state.mediaType === '2') {
            this.getWechatDailyStatistics(isFirst);//获取微信统计分析
        } else if (this.state.mediaType === '3') {
            this.getWeiboDailyStatistics(isFirst);//微博统计分析
        } else if (this.state.mediaType === '5') {
            this.getDouyinDailyStatistics(isFirst);//抖音趋势分析
        }
    }

    //获取微信趋势分析数据
    getWechatDailyStatistics(isFirst) {
        let body = {
            dimension: this.state.statisticsTypeKey || "massNumber",
            startDate: this.state.startDate.format('YYYY-MM-DD'),
            endDate: this.state.endDate.format('YYYY-MM-DD')
        };
        if (this.state.strMediaIds.length) {
            body.mediaCodes = this.state.strMediaIds;
        } else {
            body.mediaCodes = this.state.mediaCodes;
        }
        this.Actions.getWechatDailyStatistics(body, (data) => {
            let _data = data;
            if (_data && _data.length) {
                if(isFirst){
                    _data = _data.splice(0,5)
                }
                this.state.optionDataSource = _data;//保存数据源
                this.dataChange();//格式化数据
            } else {
                this.state.optionDataSource = [];//保存数据源
                this.dataChange();//格式化数据
            }
        })
    }

    //获取微博趋势分析数据
    getWeiboDailyStatistics(isFirst) {
        let body = {
            dimension: this.state.statisticsTypeKey || "totalFansAddCountYData",
            startDate: this.state.startDate.format('YYYY-MM-DD'),
            endDate: this.state.endDate.format('YYYY-MM-DD')
        };
        if (this.state.strMediaIds.length) {
            body.mediaCodes = this.state.strMediaIds;
        } else {
            body.mediaCodes = this.state.mediaCodes;
        }
        // this.state.option.xData = [];
        //后台不提供x 轴数据，前台取出时间格式化成每一天，放到统计图x轴
        // let dateArry = utils.formatEveryDay(this.state.startDate.format('YYYY/MM/DD '), this.state.endDate.format('YYYY/MM/DD '));
        // this.state.option.xData = dateArry;
        this.Actions.getWeiboDailyStatistics(body, (data) => {
            let _data = data;
            if (_data && _data.length) {
                if(isFirst){
                    _data = _data.splice(0,5)
                }
                this.state.optionDataSource = _data;//保存数据源
                this.dataChange();//格式化数据
            } else {
                this.state.optionDataSource = [];//保存数据源
                this.dataChange();//格式化数据
            }
        })
    }

    //获取抖音趋势分析数据
    getDouyinDailyStatistics(isFirst) {
        let body = {
            dimension: this.state.statisticsTypeKey || "totalFansAddCountYData",
            startDate: this.state.startDate.format('YYYY-MM-DD'),
            endDate: this.state.endDate.format('YYYY-MM-DD')
        };
        if (this.state.strMediaIds.length) {
            body.mediaCodes = this.state.strMediaIds;
        } else {
            body.mediaCodes = this.state.mediaCodes;
        }
        this.Actions.getDouyinDailyStatistics(body, (data) => {
            let _data = data;
            if (_data && _data.length) {
                if(isFirst){
                    _data = _data.splice(0,5)
                }
                this.state.optionDataSource = _data;//保存数据源
                this.dataChange();//格式化数据
            } else {
                this.state.optionDataSource = [];//保存数据源
                this.dataChange();//格式化数据
            }
        })
    }

    mediaCodes = []

    //趋势分析时间改变时候
    dataChange() {
        this.state.option.yData = [];
        this.mediaCodes = [];
        if (this.state.optionDataSource && this.state.optionDataSource.length > 0) {
            this.state.optionDataSource.forEach(item => {
                if (item.data && item.data.length > 0) {
                    let data = {
                        name: item.name,
                        data: item.data,
                        code: item._id
                    };
                    this.state.option.yData.push(data);
                    this.state.option.xData = item.day;
                    this.mediaCodes.push(item._id);
                }
            });
        } else {
            this.state.option.xData = [];
        }
        this.setState({});//更新数据
    }


    //----------------最底部获取粉丝数--------------------
    //热门文章30天和7天改变
    dataTimeChange(mediaCodes) {
        if (this.state.mediaType === '2') {
            this.getWechatHotTop10(mediaCodes);
        } else if (this.state.mediaType === '3') {
            this.getWeiboHotTop10(mediaCodes);
        } else if (this.state.mediaType === '5') {
            this.getDouyinHotTop10(mediaCodes);
        }
    }

    //获取微信热门文章
    getWechatHotTop10(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getWechatHotTop10(params, (data) => {
            let Data = data;
            if (Data && Data.length > 0) {
                Data.forEach((item, i) => {
                    item.sort = i + 1;
                });
                this.setState({hotList: Data});
            } else {
                this.setState({hotList: []});
            }
        })
    }

    //获取微博热门文章
    getWeiboHotTop10(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getWeiboHotTop10(params, (data) => {
            let Data = data;
            if (Data && Data.length > 0) {
                Data.forEach((item, i) => {
                    item.sort = i + 1;
                });
                this.setState({hotList: Data});
            } else {
                this.setState({hotList: []});
            }
        })
    }

    //获抖音热门文章
    getDouyinHotTop10(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getDouyinHotTop10(params, (data) => {
            let Data = data;
            if (Data && Data.length > 0) {
                Data.forEach((item, i) => {
                    item.sort = i + 1;
                });
                this.setState({hotList: Data});
            } else {
                this.setState({hotList: []});
            }
        })
    }

    //获取微信粉丝数
    getWeChatFansTop10(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getWeChatFansTop10(params, (data) => {
            let Data = data;
            if (Data && Data.length > 0) {
                Data.forEach((item, i) => {
                    item.sort = i + 1;
                });
                this.setState({fanSList: Data});
            } else {
                this.setState({fanSList: []});
            }
        })
    }

    //获取微博粉丝数
    getWeiBoFansTop10(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getWeiBoFansTop10(params, (data) => {
            let Data = data;
            if (Data && Data.length > 0) {
                Data.forEach((item, i) => {
                    item.sort = i + 1;
                });
                this.setState({fanSList: Data});
            } else {
                this.setState({fanSList: []});
            }
        })
    }

    //获取抖音粉丝数
    getDouYinFansTop10(mediaCodes) {
        let params = {};
        if (mediaCodes.length) {
            params.mediaCodes = mediaCodes
        }
        this.Actions.getDouYinFansTop10(params, (data) => {
            let Data = data;
            if (Data && Data.length > 0) {
                Data.forEach((item, i) => {
                    item.sort = i + 1;
                });
                this.setState({fanSList: Data});
            } else {
                this.setState({fanSList: []});
            }
        })
    }


    //热门文章点击某一行
    hotItemClick(record) {
        if (record && record.linkUrl) {
            utils.openNewWindow(record.linkUrl);
        }
    }

    //账号明细页码改变的时候
    accountPaginationChange(e, pageSize) {
        console.log(e, pageSize, 'e, pageSize')
        this.state.page = e;
        this.state.size = pageSize;
        //调用获取账号明细的方法
        this.accountChangeType(this.state.mediaCodes)
    }


    //点击热门文章的时间切换
    handleTimeTypeChange(e) {
        console.log(e.target.value);
        this.setState({timeType: e.target.value})

    }

}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
        navigateStatus: state.systemReducer.navigateStatus,
    }
}

export default connect(mapStateToProps)(ManageControlStatistics);